/// <reference path="../../BaseNew/GAdmHromadnaOperaceBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class HromadnaOperaceAdmSpisovnaKategorieDokumentu extends GContentBase {
        private hromadnaOperaceObj: HromadnaOperaceAdmSpisovnaKategorieDokumentuObj & GContent;
        private data: Gordic.AdmIsl.Interface.GAdmSpisovnaKategorieDokumentuReadDto[];
        private keys: string[];

        onContentReady() {
            this.hromadnaOperaceObj = $.extend(this as GContent, new HromadnaOperaceAdmSpisovnaKategorieDokumentuObj())
            this.hromadnaOperaceObj.createBase({
                title: "jres:33000842", //RC 33000842 : Hromadné přiřazení kategorií dokumentů spisovnám
                data: this.data,
                objectFields: ['ixs_spi_txt'],
                serviceCnt: "Gordic.Adm.WebControls.HromadnaOperaceAdmSpisovnaKategorieDokumentu",
                keys: this.keys,
                contentId: "hromadnaOperaceAdmSpisovnaKategorieDokumentu "
            })
        }
    }

    export class HromadnaOperaceAdmSpisovnaKategorieDokumentuObj extends GAdmHromadnaOperaceBase<Gordic.AdmIsl.Interface.GAdmSpisovnaKategorieDokumentuReadDto> {

        createForm(cnt: GContent<IGContentBase, any>, contentDiv: JQuery<HTMLElement>, change: OGWizardChange) {
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" })
                .addRow("jres:33000843").addField("gselectbox", Gordic.Prefabs.Select.spisspi(), { //RC 33000843 : Spisovny
                    name: "ixs_spi",
                    model: "model.ixs_spi=value.ixs_spi;model.ixs_spi_txt<=value.nazev",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    initialValue: this.options.data.map((value) => ({ ixs_spi: value.ixs_spi })),
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    serverFilters: {
                        aktivita: [100, 300, 500, 600, 900]
                    }
                }).addRow("jres:33000844").addField("gselectbox", Gordic.Prefabs.Select.ginckat(), { //RC 33000844 : Kategorie dokumentů
                    name: "ktg_typ",
                    model: "model.ktg_typ=value.ktg_typ;model.ktg_typ_txt<=value.ktg_typ_txt",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    serverFilters: {
                        aktivita: [100, 300, 500, 600, 900]
                    }
                }).addRow("jres:32131030").addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {
                    name: "aktivita",
                    model: "model.aktivita=value.aktivita;model.aktivita_txt<=value.aktivita_txt",
                    initialValue: { aktivita: 100 },
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                })
            $("<div>").appendTo(contentDiv).gform("createFrom", form);
        }

        createDefineGridData(formData: any): any {
            var cartesianResult = this.createCartesianProduct2D(this.transformDataToArrayObject(formData, ["ixs_spi", "ixs_spi_txt"]), this.transformDataToArrayObject(formData, ["ktg_typ", "ktg_typ_txt"]));
            var resultArray: any = [];
            cartesianResult.forEach((item) => {
                var data = {
                    ixs_spi: item[0]["ixs_spi"],
                    ixs_spi_txt: item[0]["ixs_spi_txt"],
                    ktg_typ: item[1]["ktg_typ"],
                    ktg_typ_txt: item[1]["ktg_typ_txt"],
                    aktivita: formData['aktivita'],
                    aktivita_txt: formData['aktivita_txt']
                }
                resultArray.push(data);
            })
            return resultArray;
        }

        createGridFormat(gridFormat: Gordic.Data.GridFormat): Gordic.Data.GridFormat {
            gridFormat.addTextColumn({
                caption: "jres:33000336",
                name: "ixs_spi_txt",
            }).addTextColumn({
                caption: "jres:33000844",
                name: "ktg_typ_txt",
            }).addTextColumn({
                caption: "jres:29929221",
                name: "aktivita_txt",
                editor: {
                    widget: "gselectbox",
                    options: $.extend(Gordic.Prefabs.Select.gincakt(), {
                        dropdown: true,
                        model: "model.aktivita=value.aktivita;model.aktivita_txt=value.aktivita_txt",
                        validators: [
                            new Gordic.Validators.Required({ stopping: true })
                        ]
                    })
                }
            })
            return gridFormat;
        }

        // Volání zatím přes CSharp (přes ISL zatím nevím jak na hromadné operace)
        saveData(data: any[]): JQueryPromise<any> {
            var saveData: Gordic.AdmIsl.Interface.GAdmSpisovnaKategorieDokumentuSaveDto[] = [];
            data.forEach((item) => {
                saveData.push({
                    ixs_spi: item['ixs_spi'],
                    ktg_typ: item['ktg_typ'],
                    aktivita: item['aktivita'],
                    NewRecord: true
                })
            })
            return this.getServiceCnt().call("SaveHromadne", { saveData: saveData }).done((results) => {
                this.createResultData(results)
            })
        }

        validateRows(data: any): Gordic.Validators.GridError[] {
            return [];
        }

        testExistMethod(data: any[]): JQueryPromise<any> {
            return $.Deferred()
        }
    }
}